import { Box, Typography } from "@braintrust/braintrust-ui-components";
import { MarkdownContent } from "@js/components/markdown-content";

import { SectionTitle } from "../section-title";

type DescriptionProps = {
  title: string;
  description: string;
};

export const Description = ({ description, title }: DescriptionProps) => {
  return (
    <Box>
      <SectionTitle title={title} />
      <Typography
        component="div"
        color="secondary"
        style={{ overflowWrap: "break-word" }}
        size="medium"
        sx={{ mb: 2 }}
      >
        <MarkdownContent markdown={description} />
      </Typography>
    </Box>
  );
};
